import { SET_INSTANCE } from '../constants'

const InitState = {
  instance: null,
}

export default function (state = InitState, action: any) {
  switch (action.type) {
    case SET_INSTANCE:
      return { ...state, instance: action.payload }
    default:
      return state
  }
}
